(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderRetransmissionDialogController', HistoryLoaderRetransmissionDialogController);

    HistoryLoaderRetransmissionDialogController.$inject = ['$uibModalInstance', '$filter', 'MegafonHistoryLoader', 'CianHistoryLoader', 'AlertService', 'entity', '$state'];

    function HistoryLoaderRetransmissionDialogController($uibModalInstance, $filter, MegafonHistoryLoader, CianHistoryLoader, AlertService, entity, $state) {
        console.log("TEST 8");
        var vm = this;

        vm.clear = clear;
        vm.confirmRetransmissionHistory = confirmRetransmissionHistory;
        vm.startTime = entity.startTime;
        vm.endTime = entity.endTime;
        vm.historyProviderSelector = entity.historyProviderSelector;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        function confirmRetransmissionHistory() {
            if(vm.historyProviderSelector == 'Megafon') {
                MegafonHistoryLoader.retransmissionHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0)},
                    onRetransmissionSaveSuccess, onRetransmissionSaveError);
                $uibModalInstance.close(true);
                console.log("TEST 5");
                $state.go('history-loader.retransmission-loading');
                console.log("TEST 6");
            } /*else if(vm.historyProviderSelector == 'Cian') {
                CianHistoryLoader.retransmissionHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT00:00:00.000", 0)},
                    onRetransmissionSaveSuccess, onRetransmissionSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.retransmission-loading');
            } */else {
                console.log("TEST 7");
            }
        }

        /*function onSaveSuccess(result) {
            if(result.count > 0) {
                AlertService.warning("history-loader.newRecordsLoaded", result);
            } else {
                AlertService.warning("history-loader.noNewRecords");
            }
            $state.go('history-loader');
        }

        function onSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.retransmissionHistoryProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }*/

        function onRetransmissionSaveSuccess (result) {
            AlertService.warning("history-loader.retransmissionStarted", result);
            $state.go('history-loader');
        }

        function onRetransmissionSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.historyProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }

    }
})();
